import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import HBox from 'components/common/HBox';
import CpfRatioBox from 'components/pages/Report/ReportDiet/CpfRatioBox';
import VBox from 'components/common/VBox';
import * as Luxon from 'luxon';

export default function BloodGlocoseDialogDietTable(props) {
  const {
    data,
  } = props;

  const {
    bldsugr_graph_list = [],
    // bld_sugr_time,
    // bld_sugr_value,
    // max_bld_sugr_yn,
    postprand2h_max_bldsugr_time,
    postprand2h_max_bldsugr_time_zone_tp_cd,
    bldsugr_before_meal,
    postprand2h_max_bldsugr,
    postprand2h_bldsugr,
    postprand2h_bldsugr_rise_w,
    postprand2h_bldsugr_tp,
    postprand_abnrml_bldsugr_min,
    main_food_list = [],
    // intaken_time,
    // main_food_nm,
    // main_food_cal,
    total_intaken_cal,
    carbo_rate,
    protein_rate,
    fat_rate,
    postprand_active_time,
    postprand_step_cnt,
    postprand_burn_cal,
    bolus_cnt,
    bolus_amt,
    bolus_time,
  } = data;

  return (
    <table>
      <tbody>
        <tr>
          <th>
            <div>
              {T('대표메뉴')}
            </div>
          </th>
          <td>
            <VBox>
              {main_food_list.map((item, index) => {
                const {
                  intaken_time,
                  main_food_nm,
                  main_food_cal,
                } = item;
                const time = Luxon.DateTime.fromFormat(intaken_time, 'yyyyMMddHHmmss').toFormat('HH:mm');
                return (
                  <div key={index}>
                    {T('{0} - {1} ({2} kcal)', time, main_food_nm, main_food_cal)}
                  </div>
                );
              })}
            </VBox>
          </td>
        </tr>
        <tr>
          <th>
            <div>
              {T('총 섭취칼로리')}
            </div>
          </th>
          <td>
            <div>
              {T('{0} kcal', total_intaken_cal)}
            </div>
          </td>
        </tr>
        <tr>
          <th>
            <div>
              {T('탄단지 비율')}
            </div>
          </th>
          <td>
            <HBox center vcenter>
              {T('{0}-{1}-{2} %', carbo_rate, protein_rate, fat_rate)}
            </HBox>
          </td>
        </tr>
      </tbody>
    </table>
  );
}
